var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-magnifier'></i> Pengajuan FTZ"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mx-3 my-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto pr-3 pb-3"
  }, [_vm._v("\n         \n      ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_mohon')
      }
    }
  }, [_vm._v("Tgl Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_setuju')
      }
    }
  }, [_vm._v("No Setuju "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_setuju')
      }
    }
  }, [_vm._v("Tgl Setuju "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_setuju))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_setuju))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.nama_ijin))]), _vm._v(" "), _c('td', {
      style: ('background-color:' + _vm.tes(bl.status))
    }, [_vm._v(_vm._s(bl.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/browseftz/list/' + bl.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Catatan Petugas",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opencatatan(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list-ul"
    })]), _vm._v(" "), (bl.status == '90') ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Ajukan Kembali"
      },
      on: {
        "click": function($event) {
          _vm.opennew(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e()], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "fade": "",
      "hide-footer": "",
      "title": "Catatan Petugas",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ModalCatatan = false
      }
    },
    model: {
      value: (_vm.ModalCatatan),
      callback: function($$v) {
        _vm.ModalCatatan = $$v
      },
      expression: "ModalCatatan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', {
    staticClass: "align-middle"
  }, [_c('th', [_vm._v("Nama Pegawai")]), _vm._v(" "), _c('th', [_vm._v("Level Pemeriksa")]), _vm._v(" "), _c('th', [_vm._v("Catatan")]), _vm._v(" "), _c('th', [_vm._v("Wkt Selesai")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.catatan), function(catat) {
    return _c('tr', {
      key: catat.NAMA
    }, [_c('td', [_vm._v(_vm._s(catat.NAMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.ur_pemeriksa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.catatan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.wk_selesai))])])
  }))])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-632d6b56","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Brows/browseftz.vue
// module id = 302
// module chunks = 0